import React from 'react'
import { IconBoltFilled } from '@tabler/icons-react'

export const LightningBoltIcon = () => {
  return (
    <div className="icon-container__square" style={{ background: 'var(--gradient-brand)' }}>
      <IconBoltFilled />
    </div>
  )
}
